import { render, staticRenderFns } from "./AgentCorpMail.vue?vue&type=template&id=66576a44&scoped=true&"
import script from "./AgentCorpMail.vue?vue&type=script&lang=js&"
export * from "./AgentCorpMail.vue?vue&type=script&lang=js&"
import style0 from "./AgentCorpMail.vue?vue&type=style&index=0&id=66576a44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66576a44",
  null
  
)

export default component.exports